
export function NewValueChildViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    isElementDeletable: true,
    editElementModalController: 'editValueChildController',
    editElementModalTemplate: require('./editValueChild.modal.html'),

    angularTemplate: `
    <div layout="column">
      <span ng-if="elementData.value"> {{elementData.value}} </span>
      <span ng-if="!elementData.value" translate-once="parameters/quick_replies/details/graph/conditions-variable-multiple/new-value"> </span>
    </div>
    `,

    disableRemove: function () {
      const boxView = this.boxView();
      return boxView.numberOfValueChild <= 2;
    },

    removeElement: function () {
      const boxView = this.boxView();
      boxView.numberOfValueChild--;
      this.model.remove();
      boxView.resizeBox();
      boxView.updateValidity();
    },

    afterEditElement: function () {
      const boxView = this.boxView();
      setTimeout(() => boxView.updateValidity());
    },

    boxView: function () {
      let parent = this.model.getAncestors()[0];
      return this.paper.findViewByModel(parent);
    }
  })
}
